import React from "react";
import Head_logo from "../../data/img/head_log.png"

const Footer=()=>{
    return(
        <footer id="footer" role="footer">
            <div className="footer-logo">
                <a href="/"><img src={Head_logo} ></img></a>
                <h5>2003. 태성ENG All Rights Reserved.</h5>
            </div>
            <div className="footer-shot">
                <h3>빠른링크</h3>

                <table>
                    <tr>
                        <td>
                        <a href="/lathe"><h4>선반/CNC</h4></a>
                        <a href="/mill"><h4>머시닝/밀링</h4></a>
                        <a href="/machine_etc"><h4>용접기및기타</h4></a>
                        <a href="/question"><h4>위치 및 문의</h4></a>

                        </td>
                        <td>
                        <a href="/Shaft_img"><h4>펌프샤프트</h4></a>
                        <a href="/Steel_img"><h4>스틸류</h4></a>
                        <a href="/Sus_img"><h4>서스류</h4></a>
                        <a href="/Al_img"><h4>AL류</h4></a>
                        <a href="/MCetc_img"><h4>MC 및 기타류</h4></a>

                        </td>
                    </tr>
                </table>

            </div>
            <div className="footer-location">
                <h3>연락처</h3>
                <h5>TEL : 032-584-5676</h5>
                <h5>FAX : 032-584-5675</h5>
                <h3>이메일</h3>
                <h5>tsengceo@daum.net</h5>
                <h5>saehwaeng2021@daum.net</h5>
                <h3>주소</h3>
                <h5>인천시 서구 보도진로 82-13</h5>
            </div>
        </footer>
    )
}

export default Footer;